<template>
  <el-dialog title="恢复线索" :visible.sync="visible" width="30%">
    <p>确认恢复线索？恢复后可继续跟进。</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { openClue } from "@/api/crm/clue";

export default {
  name: "OpenClueDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      clueId: null,
      informantName: ""
    };
  },
  created() {
  },
  components: {
  },
  watch: {
  },
  methods: {
    open (clueId, informantName) {
      if (!clueId) {
        this.msgError("没有选中任何记录")
        return
      }
      this.clueId = clueId
      this.informantName = informantName
      this.visible = true
    },
    confirm () {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading'
      });
      openClue({id: this.clueId}).then(response => {
        this.$emit('success')
        this.visible = false
        loading.close();
        this.msgSuccess("线索恢复成功");
      }).catch(error => {
        loading.close()
      })
    }
  }
};
</script>
